import React from 'react';
import {} from 'react-native';
import Reanimated from 'react-native-reanimated';
import { IRollInPresentationProps } from './';

export const RollInPresentation: React.FC<IRollInPresentationProps> = (
  props,
) => {
  return (
    <Reanimated.View style={props.containerStyle}>
      {props.children}
    </Reanimated.View>
  );
};
